var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6666 21H6.99999V7H11.6666V9.33333C12.6614 8.0678 14.1699 7.31333 15.7791 7.2765C18.6732 7.29257 21.0084 9.64761 21 12.5417V21H16.3333V13.125C16.1467 11.8214 15.0287 10.8542 13.7118 10.857C13.1358 10.8752 12.5921 11.1274 12.2062 11.5554C11.8202 11.9834 11.6254 12.5502 11.6666 13.125V21ZM4.66666 21H0V7H4.66666V21ZM2.33333 4.66667C1.04467 4.66667 0 3.622 0 2.33333C0 1.04467 1.04467 0 2.33333 0C3.62199 0 4.66666 1.04467 4.66666 2.33333C4.66666 2.95217 4.42083 3.54566 3.98324 3.98325C3.54566 4.42083 2.95217 4.66667 2.33333 4.66667Z",
    fill: "#747683"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.99abb43de993347a06859e781bf51385.svg";
export { ForwardRef as ReactComponent };